import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { FormatError } from '@Models';
import { formater_error } from '@Api';
import { FormatErrorSeverityMapper } from './format-error-severity.mapper';

@injectable()
export class FormatErrorMapper {
  @inject(TYPES.Mapper.FormatErrorSeverityMapper)
  private _formatErrorSeverityMapper!: FormatErrorSeverityMapper;

  public map(item: formater_error): FormatError {
    return {
      message: item.message,
      severity: this._formatErrorSeverityMapper.map(item.severity),
    } satisfies FormatError as FormatError;
  }
}
